
import React from "react";
import {router, usePage} from "@inertiajs/react";
import {useLaravelReactI18n} from "laravel-react-i18n";
import InertiaTable from "laravel-inertia-react-table";
import {mdiPlus} from "@mdi/js";
import Icon from "@mdi/react";
import {Button} from "react-bootstrap";

export default function RecurringTransactions(props) {
    const { t } = useLaravelReactI18n();
    const { recurringtransactions } = usePage().props;

  const handleAddClick = () => {
    router.get('recurring-transactions/create');
  }

  const customToolbarButtons = (<Button variant="secondary" onClick={handleAddClick}><Icon path={mdiPlus} size={1}/></Button>);

  const handleRowClick = (recurringTransaction) => {
    router.get('recurring-transactions/'+recurringTransaction.id+'/edit');
  }

  return (<InertiaTable data={ recurringtransactions } customToolbarButtons={customToolbarButtons} onRowClick={handleRowClick}/>);
}



